import { type LucideIcon, Tags } from 'lucide-react';

export const LabelsIcon: LucideIcon = Tags;
